/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from 'react'
import { Redirect, Switch, Route } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import { BasePage } from './BasePage'
import { Logout, AuthPage } from './modules/Auth'
import ErrorsPage from './modules/ErrorsExamples/ErrorsPage'
import { Layout } from '../_metronic/layout'

export function Routes() {
	const { isAuthorized } = useSelector(
		({ auth }) => ({
			isAuthorized: auth.user != null,
		}),
		shallowEqual
	)

	if (!isAuthorized) {
		return (
			<Switch>
				<Route
					path='/auth/login/:status?/:auth_token?/:refresh_token?'
					component={AuthPage}
				/>
				<Route path='/error' component={ErrorsPage} />
				<Route path='/logout' component={Logout} />
				<Redirect to='/auth/login' />
			</Switch>
		)
	}

	return (
		<Switch>
			<Redirect from='/auth' to='/' />
			<Route path='/error' component={ErrorsPage} />
			<Route path='/logout' component={Logout} />
			<Route
				path='/'
				render={() => (
					<Layout>
						<BasePage />
					</Layout>
				)}
			/>
		</Switch>
	)
}
